module.exports = __webpack_public_path__ + "img/logo-transparent.816db7e2.png";